export type PartnerboxMerchant = {
  profileActive?: boolean | null
  publicId?: number | null
  slug?: string | null
}

export function hasActivePartnerProfile(
  merchant: PartnerboxMerchant | null | undefined
): merchant is PartnerboxMerchant & { publicId: number; slug: string } {
  return Boolean(merchant?.profileActive && merchant?.publicId && merchant?.slug)
}
